module.exports = __webpack_public_path__ + "static/ampol-stats-3aa8c7585ff38be84f8940730becfc83.png";